import { useCallback } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';

import { authSelectors } from 'app-components/flux/auth';
import { localPreferences } from 'app-components/utils/core';
import { getBuildConfig } from 'app-components/utils/core/config';

import { createCountDownDialogAction } from './CountDown';

const inactivityTimeoutInSeconds = getBuildConfig()?.inactivity_timeout_in_seconds || 900;

const UserIdle = () => {
  const dispatch = useDispatch();
  const isAuthenticatedWithDataSetId = useSelector(authSelectors.isAuthenticatedWithDataSetId);
  const idleTimerDisabled = Boolean(localPreferences.getKeepLoggedIn());
  const onIdle = useCallback(() => {
    if (isAuthenticatedWithDataSetId) {
      dispatch(createCountDownDialogAction());
    }
  }, [isAuthenticatedWithDataSetId, dispatch]);
  useIdleTimer({
    disabled: idleTimerDisabled,
    timeout: inactivityTimeoutInSeconds * 1000,
    onIdle,
  });

  return null;
};

export default UserIdle;
